import { render } from "./LinkComponent.vue?vue&type=template&id=0637844c&scoped=true&ts=true"
import script from "./LinkComponent.vue?vue&type=script&lang=ts"
export * from "./LinkComponent.vue?vue&type=script&lang=ts"

import "./LinkComponent.vue?vue&type=style&index=0&id=0637844c&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0637844c"]])

export default __exports__